import React from "react";
import { useLocation } from "react-router-dom";
import BEEEModuleSubtopic from "../BEEEModuleSubtopic";

const ElectricalMachines = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <BEEEModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Electrical Machines"
      videos={[
        "https://www.youtube.com/embed/JZorxInZ7pU",
        "https://www.youtube.com/embed/rLXyNxF36_U",
        "https://www.youtube.com/embed/3y0Y4C5bVIU",
        "https://www.youtube.com/embed/qXVAYN-OcfA",
        "https://www.youtube.com/embed/rPtqmIAe93Y",
        "https://www.youtube.com/embed/7MUUXkFu6m4",
        "https://www.youtube.com/embed/awrUxv7B-a8",
        "https://www.youtube.com/embed/_tvMPIn59nQ",
        "https://www.youtube.com/embed/UOEC8FijUFQ",
        "https://www.youtube.com/embed/lcvDixHYA10"
      ]}
      takeaways={[
        { text: "Learn all the construction, working principle and applications of DC machines." },
        { text: "Learn all generator, motor and transformer questions." },
        { text: "Don't neglect special motors." }
      ]}
      questions={[
        "Describe the working principles of conventional DC motor with the aid of suitable diagram. List its various type with characteristics.",
        "Write the principle of operation, and applications of the following electrical machines: a) BLDC motor b) Stepper Motor",
        "List the type of DC motors. Also, give the electrical equivalent circuits and applications of each motor.",
        "With suitable diagram, elucidate the construction and working principle of an electrical machine that converts dc electrical energy to mechanical energy.",
        "What are the differences between separately excited dc generator? Also, with help of equivalent circuit diagram write voltage, current and power equation of all types of dc generators.",
        "Why single-phase induction motor is not self-starting? Explain working principle and operation of a single-phase capacitor start induction motor with circuit diagram."
      ]}
      exampleVideos={[]}
    />
  );
}

export default ElectricalMachines;
